import Box from "@mui/material/Box";
import {Checkbox, Collapse, FormControlLabel, FormGroup} from "@mui/material";
import React from "react";
import {produce} from "immer";

const ProjectDetailUpdateTemplatePrompts = ({
                                              showTemplateUpdateField, 
                                              updateTemplateChecked,
                                              setUpdateTemplateChecked,
                                              draftQuoteDetail,
                                              setDraftQuoteDetail,
                                              showTemplateNewField,
                                              setShowTemplateNewField,
                                              formValidQuoteDetail,
                                          }) => 
{
    const handleUpdateTemplateChecked = (e) => {
        setUpdateTemplateChecked(e.target.checked);
        setDraftQuoteDetail(produce(draftQuoteDetail, draft => {
            draft.templateName = e.target.checked ? draft.templateDetails.templateName : '';
            draft.templateId = e.target.checked ? draft.templateDetails.templateId : '';
        }));
    }

    const handleSaveAsNewTemplateChecked = (e) => {
        setShowTemplateNewField(e.target.checked);
        setDraftQuoteDetail(produce(draftQuoteDetail, draft => {
            draft.templateName = e.target.checked ? draft.templateName : '';
        }));
        if (e.target.checked) {
            formValidQuoteDetail.current.templateName = false;
        } else {
            delete formValidQuoteDetail.current.templateName;
        }
    }
    
    return (
        <>
            <Collapse in={showTemplateUpdateField}>
                <Box display="flex" alignItems="center" sx={{ ml: 2}}>
                    <FormGroup>
                        <FormControlLabel control={
                            <Checkbox
                                checked={updateTemplateChecked}
                                disabled={showTemplateNewField}
                                onChange={handleUpdateTemplateChecked}
                            />
                        } label={"Update template"} />
                        <FormControlLabel control={
                            <Checkbox
                                checked={showTemplateNewField}
                                onChange={handleSaveAsNewTemplateChecked}
                                disabled={updateTemplateChecked}
                                inputProps={{ 'aria-label': 'save-template' }}
                            />
                        } label={"Save as new template"} />
                    </FormGroup>
                </Box>
            </Collapse>
        </>
    )
}

export default ProjectDetailUpdateTemplatePrompts;